var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgExit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.8168 1.65698H12.6625C11.3222 1.65698 10.2264 2.76735 10.2264 4.10746V6.27308C10.2264 6.60867 10.4986 6.88061 10.8342 6.88061C11.1698 6.88061 11.4417 6.60867 11.4417 6.27308V4.10746C11.4434 3.4317 11.9867 2.88194 12.6625 2.87224H20.8168C21.487 2.87224 22.0144 3.4374 22.0144 4.10746V19.82C22.0223 20.486 21.4889 21.0324 20.8229 21.0402H12.6627C11.9896 21.0377 11.4446 20.4929 11.4417 19.82V17.6996C11.4417 17.3638 11.1698 17.0918 10.8342 17.0918C10.4986 17.0918 10.2264 17.3638 10.2264 17.6996V19.82C10.2301 21.1639 11.3186 22.2522 12.6625 22.2554H20.8168C22.1544 22.2505 23.2349 21.1616 23.2296 19.8238V4.10746C23.2296 2.76735 22.1571 1.65698 20.8168 1.65698Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.81528 12.5945H17.1958C17.5314 12.5945 17.8036 12.3224 17.8036 11.9868C17.8036 11.6514 17.5314 11.3792 17.1958 11.3792H2.68036L5.79785 7.77565C6.01772 7.52005 5.99036 7.13505 5.73723 6.9129C5.48468 6.69208 5.101 6.71773 4.88037 6.9701V6.97048L0.950868 11.4965C0.806063 11.6156 0.724539 11.795 0.729859 11.9822C0.73556 12.1698 0.827536 12.3442 0.979373 12.4545L4.90926 16.3843C5.14661 16.6217 5.53142 16.6217 5.7684 16.3843C6.00271 16.1544 6.00632 15.7785 5.77657 15.5442C5.77391 15.5417 5.77125 15.5391 5.7684 15.5364L2.81528 12.5945Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExit);
export default __webpack_public_path__ + "static/media/exit.3965a721814531627dcf9db6e9810dc8.svg";
export { ForwardRef as ReactComponent };